module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter-footer"
  }, [_c('div', {
    staticClass: "chapter-square-footer shrink-on-active",
    on: {
      "click": function($event) {
        return _vm.changePage('settings')
      }
    }
  }, [_c('inline-svg', {
    staticClass: "svg-footer",
    attrs: {
      "src": _vm.page == 'settings' ?
        require('../../assets/svg/AccountOn.svg').default :
        require('../../assets/svg/AccountOff.svg').default
    }
  }), _vm._v(" "), _c('p', {
    class: {
      chaptersquarefooterselected: _vm.page == 'settings'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("chapter.chapter-footer.user")) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chapter-square-footer shrink-on-active",
    on: {
      "click": function($event) {
        return _vm.changePage('dictionary')
      }
    }
  }, [_c('inline-svg', {
    staticClass: "svg-footer",
    class: {
      svgfooterselected: _vm.page == 'dictionary'
    },
    attrs: {
      "src": _vm.page == 'dictionary' ?
        require('../../assets/svg/DictionaryOn.svg').default :
        require('../../assets/svg/DictionaryOff.svg').default
    }
  }), _vm._v(" "), _c('p', {
    class: {
      chaptersquarefooterselected: _vm.page == 'dictionary'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("chapter.chapter-footer.dict")) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chapter-square-footer shrink-on-active",
    on: {
      "click": _vm.goToCourse
    }
  }, [_c('inline-svg', {
    staticClass: "svg-footer",
    class: {
      svgfooterselected: _vm.page == 'main'
    },
    attrs: {
      "src": _vm.page == 'main' ?
        require('../../assets/svg/CourseOn.svg').default :
        require('../../assets/svg/CourseOff.svg').default
    }
  }), _vm._v(" "), _c('p', {
    class: {
      chaptersquarefooterselected: _vm.page == 'main'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("chapter.chapter-footer.curse")) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-537ba9b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter/chapter-footer.vue
// module id = 531
// module chunks = 0